import React from 'react';
import cn from 'classnames';
import BodyText from "../../../Typography/texts/BodyText";
import styles from './TabItem.module.scss';
const getStripClassName = (activeTabStyle, stripThickness) => {
    if (activeTabStyle === 'underline') {
        return styles.tab;
    }
    switch (stripThickness) {
        case 'small':
            return styles.smallStrip;
        case 'large':
            return styles.largeStrip;
        case 'regular':
        default:
            return styles.regularStrip;
    }
};
const getActiveTabClassName = (activeTabStyle, isOpen) => {
    if (!isOpen) {
        return styles.tab;
    }
    switch (activeTabStyle) {
        case 'underline':
            return styles.underline;
        default:
            return styles.tab;
    }
};
const TabItem = ({ activeTabStyle = 'normal', tab, isOpen, handleClick, stripThickness, }) => {
    return (React.createElement("div", { key: tab.id, className: styles.listItem },
        React.createElement("button", { id: tab.id, type: "button", role: "tab", "aria-selected": isOpen, "aria-controls": `tabpanel-${tab.id}`, className: cn(isOpen && styles.open, styles.tab, getStripClassName(activeTabStyle, stripThickness), getActiveTabClassName(activeTabStyle, isOpen)), onClick: handleClick },
            React.createElement(BodyText, { Tag: "span" }, tab.heading))));
};
export default TabItem;
//# sourceMappingURL=TabItem.js.map